import { logWebRtcEvent } from './voiceWebRtcLog';

/** @type {MediaStream|null} */
let cachedLocalAudioStream = null;

/**
 * @returns {Promise<MediaStream>}
 */
export async function acquireLocalAudioStream() {
  if (cachedLocalAudioStream?.active) {
    const tracks = cachedLocalAudioStream.getAudioTracks();
    if (tracks.length > 0 && tracks.every((track) => track.readyState === 'live')) {
      tracks.forEach((track) => {
        const audioTrack = track;
        audioTrack.enabled = true;
      });
      return cachedLocalAudioStream;
    }
  }
  if (cachedLocalAudioStream) {
    cachedLocalAudioStream.getTracks().forEach((track) => track.stop());
    cachedLocalAudioStream = null;
  }
  const stream = await navigator.mediaDevices.getUserMedia({
    audio: {
      echoCancellation: true,
      noiseSuppression: true,
      autoGainControl: true
    },
    video: false
  });
  cachedLocalAudioStream = stream;
  logWebRtcEvent('sdk.localAudioReady', {
    trackCount: stream.getAudioTracks().length
  });
  return stream;
}

function releaseCachedLocalAudioStream() {
  if (!cachedLocalAudioStream) return;
  cachedLocalAudioStream.getTracks().forEach((track) => track.stop());
  cachedLocalAudioStream = null;
}

/**
 * Warm microphone permission + audio track before FreeSWITCH INVITE (speeds ICE/DTLS on answer).
 */
export async function prefetchAgentLocalAudioStream() {
  await acquireLocalAudioStream();
}

/**
 * Stops mic capture so the browser tab indicator and OS mic state return to normal.
 * Next answer/outbound flow will call getUserMedia again.
 */
export function releaseAgentLocalAudioCapture() {
  releaseCachedLocalAudioStream();
}
